import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { combineLatest, map, Observable, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-option-button',
    templateUrl: './option-button.component.html',
    styleUrls: ['./option-button.component.scss'],
    standalone: false
})
export class OptionButtonComponent extends BaseComponent implements OnInit {

  @Input() disabled: boolean = false;
  @Output() clicked = new EventEmitter();

  public selectedMode: string = 'Save';
  public dropdownOpen: boolean = false;
  public mode: 'viewer' | 'review' = 'viewer';
  public shouldAutoAdvance$: Observable<boolean> = this.docViewerStore.simpleState$.pipe(map((current) => current.shouldAutoAdvance));
  public shouldPropagateCoding$: Observable<boolean> = this.docViewerStore.simpleState$.pipe(map((current) => current.shouldPropagateCoding));

  constructor(
    private docViewerStore: DocViewerStore,
  ) {
    super();
  }

  public ngOnInit(): void {
    const saveOption$ = combineLatest([this.shouldAutoAdvance$, this.shouldPropagateCoding$, this.docViewerStore.simpleState$]);
    saveOption$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(([autoAdvance, propagateCoding, current]) => {
      this.mode = current.mode;
      if (this.mode === 'review') {
        autoAdvance = true;
      }

      let message = '';
      if (propagateCoding && autoAdvance)
        message = 'Save, Propagate & Continue';
      else if (propagateCoding && !autoAdvance)
        message = 'Save & Propagate';
      else if (!propagateCoding && autoAdvance)
        message = 'Save & Continue';
      else
        message = 'Save'

      this.selectedMode = message;
    });
  }

  public toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  public toggleAutoAdvance(shouldAutoAdvance: MatCheckboxChange): void {
    this.dropdownOpen = false;
    this.docViewerStore.updateState((currentState) => {
      currentState.shouldAutoAdvance = shouldAutoAdvance.checked;
      return currentState;
    });
  }

  public togglePropagateCoding(shouldPropagateCoding: MatCheckboxChange): void {
    this.dropdownOpen = false;
    this.docViewerStore.updateState((currentState) => {
      currentState.shouldPropagateCoding = shouldPropagateCoding.checked;
      return currentState;
    });
  }
}
